<template>
  <div class="animated fadeIn">
   
    <b-row>
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
            <strong>{{keyword}} Shipment List</strong> 
             <b-button style="float:right" type="submit" size="md" variant="primary" @click="$router.go(-1)">AWB List</b-button> 
          </div>
          <b-row >
           
          <b-col md="12" >
        
            <div class="tab-panel" >
              
              <b-row class="mt-2 mb-2"> 


<!--     <b-col sm="3" >
     
<ejs-multiselect id='multiselect' placeholder="Select Rider" v-model="value2" :dataSource='options'  :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='agentfields'   enableGroupCheckBox="true" mode="CheckBox" 
></ejs-multiselect>
      
  </b-col> -->
<!--                 <b-col sm="3">
  <div id='container' style="margin:50px auto 0; width:250px;">
        <br>     
<ejs-multiselect id='multiselect' placeholder="Select vendor" v-model="value3" :dataSource='vendoroptions'  :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"     :fields='agentfields'   enableGroupCheckBox="true" mode="CheckBox" 
></ejs-multiselect>
          </div>




                </b-col> -->

            <b-col sm="5">
                  <!-- <div id='container' style="margin:50px auto 0; width:250px;"> -->
                    <!-- <br> -->
                  <b-form-group label-cols-sm="3" label="Search" class="mb-0">
                    <b-input-group>
                      <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                <!-- </div> -->
                </b-col>
                 <!-- <b-col sm="2">
            <b-button type="submit" size="md" variant="primary" @click="getdashboardAwblist"> Search</b-button> 
                 </b-col> -->
             <!--  <b-col sm="2"> 
              <b-button type="submit" size="md" variant="primary" @click="cleardashboardAwblist"> Clear</b-button> 

              </b-col> -->
                </b-row>
                <b-row>
               <!--  <b-col md="12" class="my-1 text-right">
                    <b-button type="submit" size="md" variant="primary" @click="getdashboardAwblist"> Search</b-button> &nbsp;&nbsp;&nbsp; -->
                     
                     <!-- <b-button v-if="this.totalRows > 0" variant="primary" size="md" @click="downloadCSV">Download </b-button>  --> 
                <!-- </b-col> -->
                 
                 <b-col sm="12" class="text-right">
                         <p > <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
                        </b-col>           
              
            </b-row>
            <div id="overlay" >
             <div class="loader"></div>
           </div>

              <b-table show-empty stacked="md"  :items="items"  :fields="fields"  :current-page="currentPage"  :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered" :bordered="bordered"    :outlined="outlined" :busy="isBusy" >
              <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>   
              <template slot="mpsvalue" slot-scope="row">
                <span>&#8377; {{row.item.mpsvalue}}</span>
              </template> 
              <template slot="physicalweight" slot-scope="row">
                <span> {{row.item.physicalweight}} {{row.item.physicalweightunit}}</span>
              </template> 
              <template slot="length" slot-scope="row">
                <span>{{row.item.length}} {{row.item.lbhunit}}</span>
              </template>  
               <template slot="breadth" slot-scope="row">
                <span>{{row.item.breadth}} {{row.item.lbhunit}}</span>
              </template> 
               <template slot="height" slot-scope="row">
                <span>{{row.item.height}} {{row.item.lbhunit}}</span>
              </template> 
                  </b-table> 


            

            </div>

          
           
             </b-col>
          </b-row> 
        </b-card>
       
      </b-col>
    </b-row> 
     <b-col md="6" class="my-1" v-if="this.totalRows > 10">
        <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              class="my-0"
            ></b-pagination>
      </b-col> 




  </div>   


</template>
<script>
// import CONSTANTS from "@/utils/constants";
// import Utils from "@/utils";
// //import shipmentstatuslist from './shipmentstatuslist.vue'


// export default {
//   data: function() {
//     return {
//       activeTab: 0,
//       //shipmentstatuslist,
//       subtitle:'',
      
//     };
//   },
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import auth from '@/utils/auth'

export default {
  data: function() {
    return {
      assigned:[],
      items:[],
      isBusy: false,
       fields: [

        { key: 'parentawb', label: 'Parent AWB', sortable: true, sortDirection: 'desc' },
          { key: 'shippingid', label: 'MPS No', sortable: true},
          { key: 'length', label: 'Length', sortable: true},
          { key: 'breadth', label: 'Breadth', sortable: true},
          { key: 'height', label: 'Height', sortable: true},
          { key: 'mpsvalue', label: 'MPS Value', sortable: true}, 
           { key: 'physicalweight', label: 'Physical Weight', sortable: true},  
          { key: 'lastmodifiedby', label: 'Updated By', sortable: true },
          { key: 'lastmodifieddate', label: 'Updated Date', sortable: true },
          { key: 'deliverystatus', label: 'Delivery Status', sortable: true },
         
          // { key: 'actions', label: 'Actions' },
      ],

      outlined: true,
      totalRows: 0,
      bordered: true,
       selected:'',
      
      currentPage: 1,
      perPage:  10,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
       keyword:'',
       parentawb:'',
      filter: null,
    
    }
  },

   computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
    },
  created: function() {

    this.id = this.$route.params.id;
    console.log("IDDDDD",this.id);
    const myArr = this.id.split(" ");
     this.keyword=myArr[0];
    this.parentawb=myArr[1];  
    this.getAwbshipmentlist();
   
    
  },
  methods: {
   
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },





    getAwbshipmentlist(){
var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      //alert("A");
      this.isBusy = true;
       

      let obj = {
        
        keyword: this.keyword,
        parentawb:this.parentawb,
        

      }
    this.$http
        .post(
          `${CONSTANTS.MISREPORT_API_URL}/getDashboardShipmentList`,obj)
            .then(result => {
              // console.log(result.body);
                this.isBusy = false;
                if(result.body.returnmsg =="Successful"){
                   
              this.items =result.body.returnvalue;
                         
                 
                  this.totalRows = result.body.returnvalue.length;
                }else {
                 this.items  = [];
                 this.totalRows = 0
                }
            }).catch(ex => {
              console.log('error', ex)
            })
      },
      // cleardashboardAwblist:function(){
      //   // this.value2=[];
      //   // this.agentmaster=[];
      //   this.options=[];
      //   this.displaydeliveryagent();
      //   this.getdashboardAwblist();
      // },



  }
};
</script>
